import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    creditUnfreezeCardAccountApplication,
    creditUnfreezeCardAccountApplicationSuccess,
    creditUnfreezeCardAccountApplicationError,
    creditUnfreezeCardAccountApplicationReset,
} from '@perpay-web/fintech/actions/entities/cardAccountApplications';

const CreditUnfreezeCardAccountApplicationDataModule = createDataModule({
    dataRequest: creditUnfreezeCardAccountApplication,
    dataSuccess: creditUnfreezeCardAccountApplicationSuccess,
    dataError: creditUnfreezeCardAccountApplicationError,
    dataReset: creditUnfreezeCardAccountApplicationReset,
});

const getRoot = (state) =>
    state.dataModules.creditUnfreezeForCardAccountApplication;
const initialValue = {};

export const creditUnfreezeForCardAccountApplicationDataModule =
    CreditUnfreezeCardAccountApplicationDataModule({
        getRoot,
        initialValue,
    });
// Add loading state
export const getIsLoading = (state) =>
    creditUnfreezeForCardAccountApplicationDataModule.getIsLoading(state);

export const getIsClarityFrozen = (state) => {
    const errors =
        creditUnfreezeForCardAccountApplicationDataModule.getErrors(state);
    return (errors && errors.isClarityFrozen) || false;
};
